var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__heart--system icon--style--fill icon--size--small",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12 3.6A3.587 3.587 0 008.4.12 3.021 3.021 0 006 1.2 3.377 3.377 0 003.48 0 3.483 3.483 0 000 3.48a4.466 4.466 0 00.84 2.4L6 12l5.16-6.24A3.738 3.738 0 0012 3.6z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }